/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:26:54
 * @LastEditors: kai.zhou
 * @LastEditTime: 2020-12-10 10:32:08
 */
export default {
  lang: "法语",
  detail: {
    name1: "téléphone",
    name2:"consultez",
    name4:"Produit",
    name5:"Informations",
    name6:"Distribution ",
    name7:"Selectionné",
    name8:"Achat",
    name9:"Ouvrir CarlcareAPP pour l'achat",
    name10:"Promotion de ventes",
    name11:"Détails du produit",
    name12:"Réduction sur la première commande",
    name13:"Promotion",
    name14:"",
  }
};
